import instance from './instance';

export type MeetingSummary = {
  decisions: string[];
  action_items: string[];
  key_takeaways: string[];
  general_summary: string;
};

export type BotAttributes = {
  recallBotId: string;
  isComplete: boolean;
  startedAt: string;
  endedAt?: string;
  createdAt: string;
  updatedAt: string;
  meetingSummary?: SummaryResponse;
  workspaceSlug: string;
  organizationSlug: string;
};

export type MeetingBot = {
  id: string;
  type: string;
  attributes: BotAttributes;
};

export type CreateBotPayload = {
  meeting_url: string;
  workspace_slug: string;
  real_time_transcription: boolean;
};

export type LeaveCallPayload = {
  workspace_slug: string;
};

export type SummaryPayload = {
  workspace_slug: string;
  refresh?: boolean; // Optional: if true, it will recompute the summary
};

export type BotResponse = {
  data: MeetingBot;
};

export type SummaryResponse = {
  data: MeetingSummary;
};

export type SummaryHistoryResponse = {
  data: MeetingBot[];
};

export const createBot = (payload: CreateBotPayload) =>
  instance.post(`/bot_management/transcriptions/start_recording`, payload);

export const leaveCall = (botId: string, payload: LeaveCallPayload) =>
  instance.put(`/bot_management/transcriptions/${botId}/leave_call`, payload);

export const getBotByWorkspaceSlug = (workspaceSlug: string) =>
  instance.get<BotResponse>(`/bot_management/transcriptions/${workspaceSlug}`);

export const getMeetingSummariesByWorkspaceSlug = (workspaceSlug: string) =>
  instance.get<SummaryHistoryResponse>(`/bot_management/transcriptions/${workspaceSlug}/summaries`);

export const getMeetingSummary = (botId: string, payload: SummaryPayload) =>
  instance.post<SummaryResponse>(`/bot_management/transcriptions/${botId}/ai_summary`, payload);
